import styled from "styled-components";
import { Link } from "react-router-dom";

const StyledLink = styled(Link)`
    text-decoration: none;
`;

const StyledGridDiv = styled.div`
    display: flex;
    max-width: 1080px;
    gap: 25px;
    margin: 65px 0 0 0;
`;

const StyledCardDiv = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    width: 220px;
    height: 235px;
    border: solid 1px #e4e4e4;
    border-radius: 16px;
    padding: 24px;
`;

const StyledCardTitle = styled.h1`
    font-family: Poppins;
    font-weight: 500;
    font-size: 20px;
    margin: 17px 0;
    color: #787878;
`;

const StyledCardText = styled.p`
    text-align: left;
    font-weight: 400;
    font-size: 15px;
    margin: 0;
    color: #787878;
`;

const StyledReportCardDiv = styled.div`
    display: flex;
    justify-content: space-between;
    width: 900px;
    height: 105px;
    border: solid 1px #e4e4e4;
    border-radius: 8px;
    padding: 24px;
`;

const StyledReportCardTitle = styled.h1`
    font-size: 17px;
    margin: 0 0 8px 0;
    color: #404040;
`;

const StyledReportCardText = styled.p`
    text-align: left;
    font-weight: 400;
    font-size: 15px;
    margin: 0;
    color: #787878;
`;

const StyledReportCardInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 20px;
`;

const StyledContainerCards = styled.div`
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const StyledContainerPage = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 60vh;
`;

const StyledContainerAutocomplete = styled.div`
    display: flex;
    justify-content: space-between;
    width: 900px;
`;

export default {
    StyledLink,
    StyledGridDiv,
    StyledCardDiv,
    StyledCardTitle,
    StyledCardText,
    StyledReportCardDiv,
    StyledReportCardTitle,
    StyledReportCardText,
    StyledReportCardInfo,
    StyledContainerCards,
    StyledContainerPage,
    StyledContainerAutocomplete,
};
